import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from "@angular/core";
import { debug } from "console";
import { ModalDirective } from "ngx-bootstrap/modal";
import { ClientConfiguation } from "@shared/_enums/clientConfiguration";
import { AlignOrder, ExportType, ListType, StatusCode } from "@shared/_enums/Common";
import { FileInfo } from "@shared/_models/common/BaseModel";
import { ListingParams } from "@shared/_models/common/listingParams";
import { FormConfigModel } from "@shared/_models/Layout/FormConfig";
import { CommonService } from "@services/app.common.service";
import { ExcelExportService } from "@services/excel-export.service";
import { ServerExportHistroy } from "../../../interface/Icommon";
@Component({
  selector: 'app-excel-export-modal',
  templateUrl: './excel-export-modal.component.html',
})
export class ExcelExportModalComponent implements OnInit {

  @ViewChild('ExportModal', { static: true }) exportModal?: ModalDirective;

  totalProcessed: number = 0;
  totalrecords: number = 0;
  pageCount: number = 0;
  inputParams = {} as ListingParams;
  totalRows: number = 0;
  pageSize = 100;
  exportType: number = 1;
    allowdRecords: number = 10000;
  private exportRecords:any[] = [];
  private pageNo = 0;
  private statusCode = StatusCode;
  private serverExport = false;
  private listingFields = [];
  private systemPage = {};
  private inProcess: number = 0;
  private batchSize: number = 1;
  private requestDelay: number = 1;
  private currentPageNumber: number = 0;
  private defaultPageSize: number = 0;

    private intervalId: any;
  private processedPages: number[] = [];
  private sentToServerPages: number[] = [];


  constructor(
    private common: CommonService, private excelExportService: ExcelExportService, private cdr: ChangeDetectorRef
  ) {
    this.defaultPageSize = this.pageSize;
  }


  ngOnInit() {
    this.serverExport = this.common.getBoolean(this.common.readClientConfiguration(ClientConfiguation.ServerExport))
    let batchSize = this.common.readClientConfiguration(ClientConfiguation.ExportBatchSize);
    let requestDelay = this.common.readClientConfiguration(ClientConfiguation.ExportRequestDelay);

    if (!this.common.isNullOrWhiteSpace(batchSize))
      // this.batchSize = parseInt(batchSize)

      if (!this.common.isNullOrWhiteSpace(requestDelay))
        this.requestDelay = parseInt(requestDelay)
    //this.cdr.detach();
  }
  changeExportType(exportType:number) {
    if (exportType == 1) {
      this.pageNo = this.inputParams.pageNo;
      this.pageSize = this.inputParams.pageSize;

    }
    else {
      this.pageNo = 0
      
      this.pageSize = this.defaultPageSize;
      if (this.inputParams.totalRows > this.allowdRecords) {
        this.totalrecords = this.allowdRecords;
        this.pageCount = Math.ceil(this.totalrecords / this.pageSize);
      } else
        this.pageCount = Math.ceil(this.inputParams.totalRows / this.pageSize);
    }
    this.exportType = exportType;
    this.cdr.detectChanges();
  }

  openModal(param: ListingParams, pageNumber:number) {
    this.reSet();
    this.inputParams = { ...param };
    if (this.exportModal)
      this.exportModal.show();
    this.currentPageNumber = pageNumber;
    this.inputParams.pageNo = pageNumber;
    this.pageSize = this.inputParams.pageSize;
    this.changeExportType(this.exportType);
  }
  closeModal() {
    if (this.exportModal)
      this.exportModal.hide();

  }
  startExport() {
    this.inProcess = 0;
    if (this.exportType == 2) {
      this.common.Loader.show();
      this.AddInQueue();
      //this.intervalId = setInterval(() => {
      //  this.AddInQueue();
      //}, 2 * 1000);
    }
    else {
      this.getListOfData();

    }
  }
  private reSet() {
    this.pageCount = 0;
    this.inProcess = 0;
    this.totalProcessed = 0;
    this.processedPages = [];
    this.exportRecords = [];
    this.sentToServerPages = [];
    this.pageNo = 0;
    this.exportType = 1;
  }
  private AddInQueue() {
    this.common.Loader.show();
    if (this.totalProcessed >= this.pageCount) {
      clearInterval(this.intervalId);
      this.doExport();
      this.insertUserExportHistory();
    }
    else {

      if (this.inProcess < this.batchSize) {
        let remaining = this.batchSize - this.inProcess;
        if (this.totalProcessed + remaining >= this.pageCount) {
          let extraRequests = this.totalProcessed + remaining - this.pageCount;
          remaining = remaining - extraRequests;
        }
        for (var i = 1; i <= remaining; i++) {

          if (this.pageNo <= this.pageCount) {
            this.pageNo++;
            this.inProcess++;
            this.getListOfData()
          }
        }
      }
    }
  }
  private getListOfData() {
    let pageNumber = this.pageNo;
    if (this.sentToServerPages.find(x => x === pageNumber) !== undefined) {
      console.log("already sent to server");
      return;
    }
    this.sentToServerPages.push(pageNumber);
    if (this.inputParams.systemPageId != -1) {
      this.common.Loader.show();
      this.inputParams.sortDirection = this.inputParams.isAscendingSort ? AlignOrder.Asc : AlignOrder.Desc;
      var params = {
        IsAscendingSort: this.inputParams.isAscendingSort ? true : false,
        SortColumn: this.inputParams.sortColumn,
        PageSize: this.pageSize,
        Skip: ((pageNumber - 1) * this.pageSize),
        TextToSearch: this.inputParams.textToSearch,
        SystemPageId: this.inputParams.systemPageId,
        ScreenName: this.inputParams.screenName,
        ControllerName: this.inputParams.controllerName,
        SearchOptions: this.inputParams.searchOptions,
        CandidateId: this.inputParams.candidateId,
        SortDirection: this.inputParams.sortDirection,
        showArchived: this.inputParams.showArchived,
        filter: this.inputParams.filter,
        Filters: this.inputParams.Filters,
        filterList: this.inputParams.filterList,
        parentFilters: this.inputParams.parentFilters,
        action: ListType.Print,
        jobId: this.inputParams.jobId,
        ExportType: "Excel"
      }

      this.common.PostData(this.inputParams.getUrl, params, false).then(data => {
        this.cdr.detectChanges();
        this.totalProcessed++;
        this.inProcess--;
        var response = data;


        if (response.status == StatusCode.OK) {
          if (this.listingFields.length === 0) {
            this.listingFields = response.resultData.headerData;
            this.systemPage = response.resultData.systemPage;
          }
          if (this.processedPages.find(x => x === pageNumber) === undefined) {
            this.processedPages.push(pageNumber);
            this.exportRecords = [...this.exportRecords, ...response.resultData.listData];
          }
          if (this.exportType == 1) {
            let $this = this;
            if (this.inputParams.selectedRecords.length > 0) {


              let refId = response.resultData.refId;;

              if (this.inputParams.systemPageId == 165) {
                refId = this.inputParams.refId;
              }

              this.exportRecords = this.exportRecords.filter(function (item) {
                return $this.inputParams.selectedRecords.includes(item[refId]);
              })
            }
            this.doExport();
          }
          else {
            setTimeout(() => {
              this.AddInQueue();
            }, this.requestDelay * 1000);
          }

        }

      });
    }

  }
  private doExport() {
    this.excelExportService.exportToExcel(this.exportRecords, this.listingFields, this.systemPage);
    this.exportModal?.hide();
    this.common.Loader.hide();
  }
  private insertUserExportHistory() {
    let serverExportHistroy  =  {} as ServerExportHistroy;
    serverExportHistroy.totalExported = this.allowdRecords;
    serverExportHistroy.totalRows = this.inputParams.totalRows;
    serverExportHistroy.systemPageId = this.inputParams.systemPageId;
    serverExportHistroy.totalPages = this.pageCount;
    this.common.PostData(this.common.ApiUrls.SystemSettings.InsertUserExportHistory, JSON.stringify(serverExportHistroy)).then(data => {
    });
  }


}
